import { render, staticRenderFns } from "./ToastRedirecionamento.vue?vue&type=template&id=fe1cb2d8"
import script from "./ToastRedirecionamento.vue?vue&type=script&lang=js"
export * from "./ToastRedirecionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports